const getters = {
  pendingInvitelist: state => {
    return state.pendingInvitelist
  },
  recrInfo: state => {
    return state.recrInfo
  },
  recruiterCompL: state => {
    return state.recruiterCompL
  },
  recruiterL: state => {
    return state.recruiterL
  },
  isContacted: state => {
    return state.isContacted
  }
}

export default getters
